<template>
    <v-card :loading="loading" :min-height="loading ? 500 : 'auto'">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-sheet class="pa-4">
            <v-autocomplete
                :items="vehicles"
                item-value="id"
                :item-text="(vehicle) => `${vehicle.brand} ${vehicle.model} - ${_.get(vehicle, 'vehicle_plate', 'Nedefinit')}`"
                v-model="form.object_id"
                v-validate="'required'"
                :error-messages="errorMessages('object_id')"
                :class="{ 'error--text': hasErrors('object_id') }"
                class="primary--text"
                name="object_id"
                label="Vehicul"
                data-vv-as="Vehicul"
                data-vv-name="object_id"
            />
            <p v-if="lastFuel">{{ lastFuel }}</p>
            <v-menu
                v-model="form.documentDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.document_date"
                        v-validate="'required'"
                        :error-messages="errorMessages('document_date')"
                        :class="{ 'error--text': hasErrors('document_date') }"
                        class="primary--text"
                        name="document_date"
                        label="Data achizitie"
                        data-vv-as="Data achizitie"
                        data-vv-name="document_date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    />
                </template>
                <v-date-picker
                    v-model="form.document_date"
                    first-day-of-week="1"
                    show-adjacent-months
                    @input="form.documentDateMenu = false"
                ></v-date-picker>
            </v-menu>
            <v-text-field
                v-model="form.document_no"
                :error-messages="errorMessages('document_no')"
                :class="{ 'error--text': hasErrors('document_no') }"
                class="primary--text"
                name="document_no"
                label="Numar document"
                data-vv-as="Numar document"
                data-vv-name="document_no"
            />
            <v-autocomplete
                :items="suppliers"
                item-value="id"
                item-text="name"
                v-model="form.supplier_id"
                v-validate="'required'"
                :error-messages="errorMessages('supplier_id')"
                :class="{ 'error--text': hasErrors('supplier_id') }"
                class="primary--text"
                name="supplier_id"
                label="Furnizor"
                data-vv-as="Furnizor"
                data-vv-name="supplier_id"
            />
            <v-text-field
                v-model="form.mileage"
                v-validate="'required'"
                :error-messages="errorMessages('mileage')"
                :class="{ 'error--text': hasErrors('mileage') }"
                class="primary--text"
                name="mileage"
                label="Rulaj actual"
                data-vv-as="Rulaj actual"
                data-vv-name="mileage"
            />
            <v-textarea
                v-model="form.remarks"
                v-validate="''"
                :error-messages="errorMessages('remarks')"
                :class="{ 'error--text': hasErrors('remarks') }"
                class="primary--text"
                name="remarks"
                label="Observatii"
                data-vv-as="Observatii"
                data-vv-name="remarks"
            />

            <v-divider></v-divider>

            <v-select
                :items="fuelTypes"
                v-model="form.items[0].name"
                v-validate="'required'"
                :error-messages="errorMessages('items.0.name')"
                :class="{ 'error--text': hasErrors('items.0.name') }"
                class="primary--text"
                name="items.0.name"
                label="Denumire produs"
                data-vv-as="Denumire produs"
                data-vv-name="items.0.name"
            />

            <v-text-field
                v-model="form.items[0].qty"
                v-validate="'required'"
                :error-messages="errorMessages('items.0.qty')"
                :class="{ 'error--text': hasErrors('items.0.qty') }"
                class="primary--text"
                name="items.0.qty"
                label="Cantitate"
                data-vv-as="Cantitate"
                data-vv-name="items.0.qty"
            />

            <v-text-field
                :value="$options.filters.number(form.items[0].amount)"
                disabled
                v-validate="'required'"
                :error-messages="errorMessages('items.0.amount')"
                :class="{ 'error--text': hasErrors('items.0.amount') }"
                class="primary--text"
                name="items.0.amount"
                label="Valoare"
                data-vv-as="Valoare"
                data-vv-name="items.0.amount"
            />

            <v-select
                v-model="form.items[0].vat_id"
                v-validate="'required'"
                :items="Static.vatRates"
                item-value="id"
                item-text="name"
                :error-messages="errorMessages('items.0.vat_id')"
                :class="{ 'error--text': hasErrors('items.0.vat_id') }"
                class="primary--text input-text-right"
                label="Cota TVA"
                name="items.0.vat_id"
                data-vv-as="Cota TVA"
                data-vv-name="items.0.vat_id"
                @change="updateItems"
            />

            <v-text-field
                v-model="form.items[0].amount_with_vat"
                v-validate="'required'"
                :error-messages="errorMessages('items.0.amount_with_vat')"
                :class="{ 'error--text': hasErrors('items.0.amount_with_vat') }"
                class="primary--text"
                name="items.0.amount_with_vat"
                label="Valoare cu TVA"
                data-vv-as="Valoare cu TVA"
                data-vv-name="items.0.amount_with_vat"
                @change="updateItems"
            />
        </v-sheet>

        <v-card-actions v-if="!loading">
            <v-btn
                :loading="form.busy"
                :disabled="errors.any() || form.busy"
                block
                color="success"
                @click="submit()"
            >
                Salveaza
                <v-icon right>
                    save
                </v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import validationError from "Mixins/validation-error";
    import {Form} from "vform";

    export default {
        mixins: [validationError],
        props: {
            id: {
                type: [Number, String],
                required: false
            }
        },
        data: () => ({
            tab: 'general',
            loading: true,
            suppliers: [],
            vehicles: [],
            /* Always Declare Your Form Object */
            form: new Form({
                id: null,
                supplier_id: null,
                type: 'FUEL',
                object_type: 'App\\Models\\Equipment',
                object_id: null,
                document_date: null,
                document_no: null,
                remarks: null,
                items: [{
                    id: undefined,
                    name: undefined,
                    qty: undefined,
                    measurement: undefined,
                    unit_price: undefined,
                    vat_id: undefined,
                    amount: undefined,
                    amount_with_vat: undefined,
                    date_expire_start: undefined,
                    date_expire_end: undefined,
                    time_expire_notify: undefined,
                    km_expire: undefined,
                    km_expire_notify: undefined
                }],
                documentDateMenu: false
            }),
            lastFuel: undefined
        }),
        computed: {
            fuelTypes () {
                let fuelTypes = this.Static.fuelTypes
                return Object.keys(fuelTypes).map((typeKey) => {
                    return {
                        value: fuelTypes[typeKey],
                        text: fuelTypes[typeKey],
                    }
                })
            }
        },
        watch: {
            'form.object_id': {
                handler(val) {
                    if (val && parseInt(val) > 0) {
                        this.loadLastFuelEntryForEquipment(val)
                    } else {
                        this.lastFuel = undefined
                    }
                }
            }
        },
        async mounted() {
            await this.loadSuppliers()
            await this.loadVehicles()
            if(this.id) {
                await this.loadResource()
            } else {
                this.form.items[0].vat_id = this._.get(this.Static.vatRates.find(
                    rate => parseFloat(rate.rate) === this.$db.Invoice.VAT_RATE
                ), 'id')
            }
            this.loading = false;
        },
        methods: {
            async loadLastFuelEntryForEquipment(equipmentId) {
                await this.$db.Expense
                    .orderBy(['-created_at'])
                    .where('fuel', true)
                    .where('object_type', this.form.object_type)
                    .where('object_id', equipmentId)
                    .include('items')
                    .limit(1)
                    .get()
                    .then(({data}) => {
                        let lastFuel = data[0]
                        if (lastFuel instanceof Object) {
                            this.lastFuel = `Ultima alimentare de "${lastFuel.items[0].name}" in valoare de ${lastFuel.amount_with_vat} a fost in data de ${lastFuel.document_date}.`
                        }
                    })
            },
            async loadSuppliers() {
                this.suppliers = await this.$db.Supplier
                    .limit(2000)
                    .get()
                    .then(({data}) => data)
            },
            async loadVehicles() {
                this.vehicles = await this.$db.Equipment
                    .where('customer_id', this.Static.selfClientId)
                    .where('active', 1)
                    .limit(2000)
                    .get()
                    .then(({data}) => data)
            },
            async loadResource() {
                let self = this;
                this.loading = true;

                let data = await this.$db.Expense
                    .include('items')
                    .find(this.id)
                    .then(({data}) => {
                        data.documentDateMenu = false

                        data.items = (data.items && data.items.length ? data.items : [{}]).map((item) => {
                            return Object.assign({
                                id: undefined,
                                name: undefined,
                                qty: undefined,
                                measurement: undefined,
                                unit_price: undefined,
                                vat_id: undefined,
                                amount: undefined,
                                amount_with_vat: undefined,
                                date_expire_start: undefined,
                                date_expire_end: undefined,
                                time_expire_notify: undefined,
                                km_expire: undefined,
                                km_expire_notify: undefined,
                                hasTimeLimit: !this._.isNil(item.date_expire_end),
                                hasMileageLimit: !this._.isNil(item.km_expire),
                                startMenu: false,
                                endMenu: false
                            }, item)
                        })
                        return data
                    })
                this.updateItems()
                self.form = new Form(data)
                this.loading = false
            },
            async submit() {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;
                self.form.busy = true;

                let model = new this.$db.Expense(self.form);
                if (this.id) {
                    model.id = this.id
                }

                model.save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                        self.$nextTick(() => self.$router.push({name: "vehicle-fuels-index"}));
                    })
                    .catch(errors => {
                        self.form.errors.set(this.form.extractErrors(errors.response))
                        this.showError()
                    }).finally(() => {
                    self.form.busy = false;
                });
            },
            updateItems() {
                this.form.items = this.form.items.map((item) => {
                    let vatRate = parseInt(this._.get(this.Static.vatRates.find(rate => parseInt(rate.id) === parseInt(item.vat_id)), 'rate', 0))
                    let amountWithVat = parseFloat(item.amount_with_vat);
                    return Object.assign(item, {
                        measurement: 'L',
                        unit_price: ((amountWithVat - amountWithVat * vatRate / (100 + vatRate)) / parseFloat(item.qty)),
                        amount: (amountWithVat - amountWithVat * vatRate / (100 + vatRate))
                    })
                })
            }
        }
    };
</script>
